import classNames from 'styles/utils/classNames';

interface Props {
  urls: string[];
  /** Max faces rendered. */
  max?: number;
  /** Avatar size, e.g. 'size-7'. */
  sizeClassName?: string;
  /** Ring color — matches the surface the stack sits on. */
  ringClassName?: string;
}

export default function AvatarStack({
  urls,
  max = 5,
  sizeClassName = 'size-7',
  ringClassName = 'border-color-bg-lightmode-primary dark:border-color-bg-darkmode-primary',
}: Props) {
  if (urls.length === 0) return null;

  return (
    <div className="flex items-center">
      {urls.slice(0, max).map((url, index) => (
        <img
          key={index}
          src={url}
          alt=""
          className={classNames(
            'rounded-full border-2 bg-color-bg-lightmode-primary object-cover',
            sizeClassName,
            ringClassName,
            index > 0 && '-ml-2',
          )}
        />
      ))}
    </div>
  );
}
